import React from 'react'
const estiloInputs = require('../../../../estilos/inputs.module.scss').default
const estiloOrcamentoEmAberto =
    require("../pendencia-cliente.module.scss").default;

export type ClienteComLimiteCreditoBloqueadoProps = {
    onChangeSenha: (senha: string) => void
    /**
     * Enter no campo de senha — o chamador liga no mesmo handler do botão Ok
     * (`PendenciaCliente_BotaoOk`). Opcional: sem ele o Enter não faz nada.
     */
    onConfirmar?: () => void
}

export const ClienteComLimiteCreditoBloqueado = (props: ClienteComLimiteCreditoBloqueadoProps) => {
    return <>
        <h4>Cliente com tipo de limite de crédito bloqueado, por favor, informe a senha de liberação.</h4>
        <div className={estiloOrcamentoEmAberto.form}>
            <label className={estiloInputs.labelObrigatorio}>Senha</label>
            <div>
                <input
                    type="password"
                    id="ClienteComLimiteCreditoBloqueado_CampoSenha"
                    autoFocus
                    autoComplete="off"
                    aria-autocomplete="none"
                    onChange={(e) => props.onChangeSenha(e.target.value)}
                    // Enter confirma, igual a clicar em Ok. `onKeyDown` e não `onKeyPress`
                    // (depreciado no React 19). A senha já chegou ao pai pelo onChange do
                    // caractere anterior, então o Ok enxerga o valor completo.
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            props.onConfirmar?.()
                        }
                    }}
                />
            </div>
        </div>
    </>
}
